export const FirearmTypeConstants = {
  SHOTGUN: '063e91de-c0aa-4327-84db-05a9a64b96b4',
  BARREL_PISTOL: '15098490-07ec-4802-8f5f-0bf2a25941b9',
  RIFLE_SEMI_AUTO: 'a01d3972-47fe-451e-8fe6-0c5e0dfae60b',
  PURPOSE_BUILT_HUNTING_HANDGUN: '23705c89-ba54-465f-98f8-199e529a65dd',
  POWERHEAD_RIFLE: 'e90757bf-edec-44f6-92f3-32e597ade221',
  BARREL_ONLY: 'db315ea5-33ab-453f-8e96-3bc2383a3155',
  REVOLVER: '882df97a-e111-4afe-b470-416693cb813e',
  RIFLE: '4e8d761b-0f43-44a1-8d65-4910d51c2b80',
  BLASER_STOCK_ACTION: '212b615c-b439-4416-ab67-51d411023eac',
  PISTOL_CALIBRE_CARBINE: '64696860-b235-41d4-a956-5e07fbe5f0b1',
  RIFLE_SLR: '6f989e15-1a0c-4b29-88eb-7a17e220544c',
  BLACK_POWDER_FIREARM: 'b3b30728-34f7-4857-ae65-7e58e4c5984d',
  BLACK_POWDER_HANDGUN_RIFLE: 'e4dde9fe-24f7-4382-97f4-8b27d88f000f',
  SELF_LOADING: '1e4957b2-6349-4ad8-b523-8b6e640202a6',
  MAIN_FIREARM_COMPONENT: 'd206c365-45b3-47d0-8c30-8d7a9f3c11d6',
  LOOSE_BARREL_ONLY: '57ec2749-77a7-4dd3-86c5-8fcc478fd55d',
  BARREL_RIFLE: 'e9c362fb-aa4c-449e-9741-92b48ffb6f96',
  POWERHEAD: 'a06ccf48-d3e5-4684-8c65-9bd65650edf8',
  SINGLE_SHOT_SPORTING_HANDGUN: '5a4599de-e077-47cb-a290-a79b5d52ca57',
  SPORT_SHOOTING_HANDGUN: '65d087fb-fcba-4a67-8ca6-aece82497629',
  HAND_SHOTGUN: '6f04344f-1221-433f-8bac-b25fcd988296',
  SELF_LOADING_RIFLE_CARBINE: '3da43254-9542-4272-8671-b535ebc8bd5f',
  HANDGUN: 'a4aa2f2c-64f5-4545-944c-b8ca4049a803',
  RECEIVER_RIFLE: '6585fbd9-8588-4e28-b858-bb4d7d11cd9c',
  BARREL_SHOTGUN: '92ddba54-3783-4fa0-9fbf-d0bca128f95d',
  BARREL_REVOLVER: '70e74a4d-8173-4062-bf18-e502c48d8db3',
  FIREARM_ACTION_ONLY: 'ea53f4ab-863d-4255-ad35-f294d9fba702',
  HAND_MACHINE_CARBINE: 'dd1cc114-6d31-4ae7-a735-f33def284f0f',
  COMBINATION: 'e3bde8b2-77c7-4fa9-abec-f49bacc5d26a',
  PISTOL: '83d219d0-b5b7-4e3d-a7e1-ff9bf3d68c2d',
};

export const isRifle = [
  FirearmTypeConstants.RIFLE_SEMI_AUTO,
  FirearmTypeConstants.POWERHEAD_RIFLE,
  FirearmTypeConstants.RIFLE,
  FirearmTypeConstants.RIFLE_SLR,
  FirearmTypeConstants.BLACK_POWDER_HANDGUN_RIFLE,
  FirearmTypeConstants.BARREL_RIFLE,
  FirearmTypeConstants.SELF_LOADING_RIFLE_CARBINE,
];

export const isHandgun = [
  FirearmTypeConstants.PURPOSE_BUILT_HUNTING_HANDGUN,
  FirearmTypeConstants.BLACK_POWDER_HANDGUN_RIFLE,
  FirearmTypeConstants.SINGLE_SHOT_SPORTING_HANDGUN,
  FirearmTypeConstants.SPORT_SHOOTING_HANDGUN,
  FirearmTypeConstants.HANDGUN,
  FirearmTypeConstants.PISTOL,
  FirearmTypeConstants.REVOLVER,
];
